import { setRequestHeadersProvider } from "@qure/qure-auth";
import { getProxyHeadersForUrl } from "./proxyAccountStore";

/**
 * Adds the proxy header to @qure/qure-auth's own requests, so its data reflects the
 * proxied account too - not just the app's requests.
 *
 * Needed because the /profile call runs on qure-auth's own axios (not axiosConnect), and
 * /profile is proxy-aware; without this the app would boot on the real user's profile
 * even while proxying.
 *
 * Call at module scope, not in a useEffect: qure-auth fires /profile on mount, which an
 * effect would run too late to catch.
 */
var registerProxyAuthHeaders = function registerProxyAuthHeaders() {
  setRequestHeadersProvider(function (_ref) {
    var url = _ref.url;
    return getProxyHeadersForUrl(url);
  });
};
export default registerProxyAuthHeaders;